module.exports = __webpack_public_path__ + "img/tanzania.c664fd8.webp";